// removed by extract-text-webpack-plugin
module.exports = {"logoIcon":"logo__logoIcon--IuVwe","logo":"logo__logo--3D5lL","animating":"logo__animating--2lbpQ","great":"logo__great--lbGNh","logoDark":"logo__logoDark--gMKOU logo__logo--3D5lL","logoWhite":"logo__logoWhite--2XC3Q logo__logo--3D5lL","fillWhite":"logo__fillWhite--3EbkH","homeStyle":"logo__homeStyle--UwydG","g":"logo__g--15I9I","r":"logo__r--33b8N","e":"logo__e--3sDhE","a":"logo__a--3pfWY","t":"logo__t--2X4hf"};


//////////////////
// WEBPACK FOOTER
// ./src/components/modules/Header/logo.css
// module id = qDz6
// module chunks = 0